/* @flow */
import { Map, Set, Record, OrderedMap } from 'immutable';

export type SearchOptionsShape = Record<{
  enclaveFilters: string[],
  includeCommunity: boolean,
}>;

export const Options = Record({
  enclaveFilters: Set(),
  includeCommunity: true,
});

export type IocResponse = Map<{
  id: string,
  type: string,
  value: string,
  indicatorType: string,
  position: number,
}>;

export type ReportResponse = Map<{
  title: string,
  id: string,
  type: string,
  position: number,
  sector: string,
  distributionType: string,
  enclaveGuids: Array<String>,
  created: number,
  updated: number,
}>;

export type SearchResponse = Record<{
  data: OrderedMap<string, IocResponse | ReportResponse>,
  moreResults: boolean,
  pageNumber: number,
  totalPageElements: number,
  totalPages: number,
  loading: boolean,
  error: boolean,
}>;

export const searchResponse = Record({
  data: OrderedMap(),
  moreResults: false,
  pageNumber: 0,
  totalPageElements: 0,
  totalPages: 0,
  loading: false,
  error: false,
});

// Like payload action but also supports field to update
export type SearchAction<T> = {
  type: string,
  payload: T,
  fields?: Array<string>,
  error?: boolean,
  meta?: Object,
};


export type viewPanelType = 'ENTITIES' | 'REPORTS' | 'ALL' ;


// WEBPACK FOOTER //
// ./src/app/modules/search/types.js